import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import * as styles from "./reviewSection.module.css";
import UserReview from "../users-reviews/usersReviews";

export default ({ node }) => {
  const { reviewHeadline, reviews } = node;
  return (
    <Box className={styles.reviewSection} pt={2} pb={2}>
      <Box mb={1}>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          textAlign={"center"}
        >
          <Grid item xs={12}>
            <h2>{reviewHeadline}</h2>
          </Grid>
        </Grid>
      </Box>
      {reviews && reviews.length > 0 ? (
        <Box pl={{ md: 4, sm: 1, xs: 1 }} pr={{ md: 4, sm: 1, xs: 1 }}>
          <Grid container spacing={3}>
            {reviews.map((review) => {
              return (
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <UserReview node={review} />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      ) : null}
    </Box>
  );
};
